/**
 * 
 * @class Support for work with the datatables
 * @author Jan Herzing
 * 
 **/

import moment from 'moment';
import JQuery from 'jquery';
let $ = JQuery

class dataTableUtils {
    static formater = {
        formatDate(date) {
            return moment(date).format("DD.MM.YYYY");
        },
        formatDateTime(date) {
            return moment(date).format("DD.MM.YYYY H:mm");
        }
    };    
    
    static localize(dataTablesSettings, LanguageISOCode) {
        var defaultContent = '<i class="text-muted">empty</i>';

        if (LanguageISOCode === 'cs') {
            defaultContent = '<i class="text-muted">nevyplněno</i>';
            dataTablesSettings.language = {
                "decimal": ".",
                "emptyTable": "Žádná data",
                "info": "Záznamy _START_ až _END_ z _TOTAL_",
                "infoEmpty": "Zobrazuji 0 z celkem 0 položek",
                "infoFiltered": "(filtrováno z _MAX_ položek)",
                "infoPostFix": "",
                "thousands": " ",
                "lengthMenu": "Zobrazit _MENU_ záznamů",
                "loadingRecords": "Načítání...",
                "processing": "Zpracování...",
                "search": "Vyhledat:",
                "zeroRecords": "Hledání neodpovídají žádné výsledky",
                "paginate": {
                    "first": "První",
                    "last": "Poslední",
                    "next": "Další",
                    "previous": "Předchozí"
                },
                "aria": {
                    "sortAscending": "seřadit vzestupně",
                    "sortDescending": "seřadit sestupně"
                }
            };
        }
        else if (LanguageISOCode === 'en') {
            //no-op english is the default language for Datatables
        }

        // set default content for all columns
        for (var col of dataTablesSettings.columns.filter(function (element) { return (typeof element.defaultContent === 'undefined'); })) {
            col.defaultContent = defaultContent;
        }

        //$.fn.dataTable.ext.order.intl(LanguageISOCode);
    }

    static registerDrawCallback(settings, callback) {
        if (!settings.drawCallbacks) {
            settings.drawCallbacks = [];
            settings.drawCallback = function () {
                let self = this;
                settings.drawCallbacks.forEach(function (c) { c(self); });
            };
        }
        settings.drawCallbacks.push(callback);
    }

    static growOnly(settings) {
        settings.preDrawCallback = function () {
            // grow-only in height
            var pageLen = this.api().page.info().length;
            var row = $(this).closest('.row');
            if (pageLen < settings.pageLength) {
                row.css('min-height', '0'); //reset min-height
            }
            else if (row.height() > Number(row.css('min-height').slice(0, -2))) {
                row.css('min-height', row.height() + 'px');
            }             

            settings.pageLength = pageLen;
        };
    }

    static enableTooltips(settings, tableExpression, options) {
        dataTableUtils.registerDrawCallback(settings, function () {
            $(tableExpression).find("[data-tooltip]").tooltip(options);
        });
    }

    static removeSearchbox(settings) {
        settings.sDom = "<'row'<'col-sm-12 col-md-6'l><'col-sm-12 col-md-6'>><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>";
    }

    static generateGenericColumns(settings, columnNames) {

        settings.columns = columnNames.filter(function (columnName) { return columnName !== ""; })
            .map(function (columnName) { return { "data": columnName, "name": columnName }; });
    }

    static buildSettings(url, onlyFieldnameDefinitions = null, completeFieldDefinitions = null, filter = [], clientSide = false) {

        var settings = clientSide ?
        {
            "processing": true,
            "serverSide": false,
            "filter": false,
            "paging": false,
            "info": false
        } :
        {
            "processing": true,
            "serverSide": true,
            "filter": true,
            "ajax": {
                "type": "POST",
                "datatype": "json",
                "contentType": "application/json",
                "url": url,
                "data": function (d) {
                    d.pageFilters = filter;
                    return JSON.stringify(d);
                }
            }
        };

        if (completeFieldDefinitions != null) {

            completeFieldDefinitions.forEach(function (val) { if (!val.name) val.name = val.data; });
            settings.columns = completeFieldDefinitions;
        }
        else {
            dataTableUtils.generateGenericColumns(settings, onlyFieldnameDefinitions);
        }

        dataTableUtils.localize(settings, this.RenderedLanguageCode);
        return settings;
    }

    /**
     * @method createDataTableDeferLoading creates a new data table by input params
     * 
     * @param tableId table name
     * @param url url function with data
     * @param onlyFieldnameDefinitions alone field names - it will generated json array for the columns
     * @param completeFieldDefinitions standard json array columns
     * @param filter json array where fields (can be equal and not equal)
     */
    static createDataTableDeferLoading(table, url, onlyFieldnameDefinitions = null, completeFieldDefinitions = null, filter = []) {
        var settings = dataTableUtils.buildSettings(url, onlyFieldnameDefinitions, completeFieldDefinitions, filter);
        settings.deferLoading = 0;
        return table.DataTable(settings);
    }

    /**
     * Well usable for ajax.data.pageFilters
     * @param {any} jsonArray array which we want to fill
     * @param {any} name field name
     * @param {any} value field value (fill this or @param input)
     * @param {any} input field value (fill this or @param value)
     * @param {any} operation comparition operation
     */
    static addToJsonArray(jsonArray, name, value, input, operation = 'smart') {
        var val = value;
        if ((val == null) && (input != null)) {

            if (input.is('[type=checkbox]')) {
                var isInd = input.parent().hasClass('indeterminate');
                val = isInd ? null : input.is(":checked");
            }
            else if (input.is('select') && operation !== 'smart')
                val = $('option:selected', input).text();
            else
                val = input.val();
        }

        if ((val != null) && (val !== '')) {
            jsonArray.push({ "key": name, "value": val, "operation": operation });
        }
    }

    static addPageFilters(dto, filters) {
        var filterFields = [];

        filters.forEach(function (val) { dataTableUtils.addToJsonArray(filterFields, val.field, val.value, val.source, val.operation); });
        dto.pageFilters = filterFields;
    }

    static addColumnFilters(table, dto, fields) {
        var filterFields = [];
        fields.forEach(function (val, i) { if (val.searchable !== false) dataTableUtils.addToJsonArray(filterFields, val.name, null, $('input, select', $(`#${dataTableUtils.columnId(table, i)}`, $(table.table().container())))); });
        dto.columnFilters = filterFields;
    }

    static addRenderer(settings, columnName, renderFunction) {
        settings.columns.find(c => c.name === columnName).render = renderFunction;
    }

    static renderStatusBadge(data, type) {
        if (type === "sort" || type === "type" || type === "filter") return data;
        return '<span class="badge b-status badge-' + data.toLowerCase() + '" title="Stav požadavku" data-tooltip></span>';
    }

    static renderEnum(data, type, row, enumSource, defaultValue) {
        if (type === "type" || type === "filter") return data;
        var item = enumSource.filter(x => x.value == data);
        return item[0] ? item[0].text : defaultValue !== undefined ? defaultValue : data;
    }

    static renderDate(data, type) {
        if (type === "sort" || type === "type" || type === "filter") return data;

        if (data)
            return this.formater.formatDate(data);
        else
            return null;
    }

    static renderDateTime(data, type) {
        if (type === "sort" || type === "type" || type === "filter") return data;

        if (data)
            return this.formater.formatDateTime(data);
        else
            return null;
    }

    static renderNumber(data, type, row, scale, fractionDigits, measureUnit) {
        if (type === "sort" || type === "type" || type === "filter") return data;

        if (data) {
            if (typeof(data) === 'string')
                data = data.replace(',', '.');

            return (data / scale).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: fractionDigits }) + measureUnit;
        }
        else
            return '';
    }

    static renderBool(data, type, row, index, color) {
        if (type === "sort" || type === "type" || type === "filter") return data;
        if (!color) color = 'text-success';

        return data ?
            `<div class="text-center"><i class="fas fa-check ${color} text-bigger" aria-hidden="true"></i></div>` :
            '';
    }

    static renderFile(data, type, row) {
        if (type === "sort" || type === "type" || type === "filter") return data;
        return `<a href="${this.Api.File.Download}/${row.id}">${data}</a>`;
    }

    static renderAddress(data, type, row, markerType) {
        if (type === "sort" || type === "type" || type === "filter") return data;
        if (data.gps)
            return `<span class='show-map' data-editable='false' data-type='${markerType}' data-name='${row['name']}' data-gps='${data.gps}'><i class='${data.countryCode ? data.countryCode.toLowerCase() : ''} flag'></i><span>${data.street}, ${data.zipCode} ${data.city}</span></span>`;
        else
            return `<i class='${data.countryCode ? data.countryCode.toLowerCase() : ''} flag'></i><span>${data.street}, ${data.zipCode} ${data.city}</span>`;
    }

    static renderSubject(data, type, row, settings) {
        if (type === "sort" || type === "type" || type === "filter") return data;

        if (data) {
            if (data.name)
                return this.renderCompany(data, type, row, settings);
            else
                return this.renderPerson(data, type, row, settings);
        }
        else
            return '';
    }

    static renderCompany(data, type) {
        if (type === "sort" || type === "type" || type === "filter") return data;

        if (data) {
            return `<span><i class='far fa-building'></i><span> ${data.name}</span></span>`;
        }
        else
            return '';
    }

    static renderPerson(data, type) {
        if (type === "sort" || type === "type" || type === "filter") return data;

        if (data) {
            if (data.displayName)
                return `<span><i class='fas fa-user'></i><span> ${data.displayName}</span></span>`;
            else
                return `<span><i class='fas fa-user'></i><span> ${data.lastName}, ${data.firstName}</span></span>`;
        }
        else
            return '';
    }

    static renderPhone(data, type) {
        if (type === "sort" || type === "type" || type === "filter") return data;

        if (data.phone) {
            return `<span><i class='fas fa-phone'></i><span> ${data.phonePrefix} ${data.phone}</span></span>`;
        }
        else
            return '';
    }

    static renderEmail(data, type) {
        if (type === "sort" || type === "type" || type === "filter") return data;

        if (data.email) {
            return `<a><i class='far fa-envelope'></i><span> ${data.email}</span></a>`;
        }
        else
            return '';
    }

    static renderEditButton(data, type, row) {
        if (type === "sort" || type === "type" || type === "filter") return "";
        return `<button type="button" class="btn btn-outline-primary mr-1 edit-object" role="button" title="Upravit" data-tooltip data-param=${row.uniqueId | row.id}><i class="fas fa-pencil-alt"></i></button>`;
    }

    static renderDeleteButton(data, type, row) {
        if (type === "sort" || type === "type" || type === "filter") return "";
        return `<button type="button" class="btn btn-outline-danger delete-object" data-toggle="modal" data-target="#confirmDelete" role="button" title="Smazat" data-tooltip data-param=${row.uniqueId | row.id}><i class="fas fa-trash-alt"></i></button>`;
    }

    static renderCheckbox(data, type, row, ns, checked, disabled) {
        if (type === "sort" || type === "type" || type === "filter") return data;
        return `<div class="custom-control custom-checkbox col-form-label py-0">
                    <input type="checkbox" class="custom-control-input table-checkbox" id="${ns}_${data}_Checkbox" ${checked ? 'checked' : ''} ${disabled ? 'disabled' : ''}>
                    <label class="custom-control-label" for="${ns}_${data}_Checkbox"><span>&nbsp;</span></label>
                </div>`;
    }

    static renderData(data, type, row, prefix) {
        if (type === "sort" || type === "type" || type === "filter") return "";
        return dataTableUtils.renderObject(prefix, row);
    }

    static renderObject(prefix, object) {
        var content = '';

        for (var property in object) {
            var name = prefix + property[0].toUpperCase() + property.substr(1);

            if (typeof object[property] === 'object')
                content += dataTableUtils.renderObject(name + '.', object[property]);
            else
                content += `<input type='hidden' name='${name}' value='${object[property]}'>`;
        }

        return content;
    }

    /**
     * It renders input elements which filter data by text
     * @param {any} table table instance
     */
    static renderHeaderFilters(table, fields) {
        var tableName = '#' + table.table().node().id;
        $(tableName + ' thead tr').clone(true).appendTo(tableName + ' thead');

        $(tableName + ' thead tr:eq(1) th').each(function (i) {
            $(this).removeClass("sorting");
            $(this).removeClass("sorting_desc");
            $(this).removeClass("sorting_asc");
            $(this).addClass("sorting_disabled");
            $(this).off('click');

            var title = $(this).text();
            if (title !== "") {
                if (dataTableUtils.columnSearchable(table, i)) {
                    $(this).attr('id', dataTableUtils.columnId(table, i));

                    var filterType = fields ? fields.find(f => f.name === dataTableUtils.columnName(table, i)).filter : '';

                    if (filterType && filterType.constructor === Array) {
                        $(this).html(`
                            <select style="font-size: 10px !important; min-width: 100px !important;" class="form-control col p-0">
                                <option value selected>Vyberte</option>
                            </select>
                        `);

                        filterType.forEach(e => $('select', $(this)).append(`<option value='${e.value}'>${e.text}</option>`));
                    }
                    else {
                        switch (filterType) {
                            case 'date':
                                $(this).html('<input type="date" style="font-size: 10px !important; min-width: 100px !important;" class="form-control col" placeholder="' + title + '" />');
                                break;

                            case 'number':
                                $(this).html('<input type="number" style="font-size: 10px !important; min-width: 100px !important;" class="form-control col" placeholder="' + title + '" />');
                                break;

                            case 'bool':
                                $(this).html(`
                                    <div class="custom-control custom-checkbox col-form-label text-center threestate-checkbox indeterminate">
                                        <input type="checkbox" class="custom-control-input" id="chb_${i}">
                                        <label class="custom-control-label" for="chb_${i}">
                                        </label>
                                    </div>
                                `);
                                break;

                            default:
                                $(this).html('<input type="text" style="font-size: 10px !important; min-width: 100px !important;" class="form-control col" placeholder="' + title + '" />');
                                break;
                        }
                    }

                    $('input, select', this).on('keyup change', function () {
                        var self = this;
                        window.setTimeout(function () {
                            if (table.column(i).search() !== self.value) {
                                table.column(i).search(self.value).draw();
                            }
                        }, 500);
                    });
                }
                else {
                    $(this).html('');
                }
            }
        });
    }

    static destroyHeaderFilters(table) {
        var tableName = '#' + table.table().node().id;
        $(tableName + ' thead tr').last().remove();
    }

    static columnSearchable(table, i) {
        return table.context[0].aoColumns[i].bSearchable;
    }

    static columnName(table, i) {
        return table.context[0].aoColumns[i].name;
    }

    static columnId(table, i) {
        return dataTableUtils.columnName(table, i).replace(/\./g, '_');
    }
}

export default dataTableUtils